import axios from 'axios'

export const BASE_URL = process.env.NODE_ENV === 'development' ? process.env.API_PATH : (process.env.STATIC_PATH_PREFIX + 'api')

export const IMAGES_URL = BASE_URL + '/documentos/get'

const env = require('../../config/prod.env')

const api = axios.create({
  baseURL: env.API_PATH,
  /* baseURL: 'https://extncal.prinex.com/PostVentaWS/', */
  withCredentials: false
})

export default api
